module.exports = __webpack_public_path__ + "img/not-authorized-dark.6956bb48.svg";